import React, { useState, useRef, useEffect } from 'react'
import { useLocation } from "react-router-dom";

import slider from "../../Assets/Images/Product-page/Multivitamin/slider.png"
import slider2 from "../../Assets/Images/Product-page/AntidepressentRange/slider.png"
import slider3 from "../../Assets/Images/Product-page/NeuropathyManagement/slider.png"
import slider4 from "../../Assets/Images/Product-page/AntiEpilepticRange/slider.png"
import slider5 from "../../Assets/Images/Product-page/AnitMigraneRange/slider.png"
import slider6 from "../../Assets/Images/Product-page/AntiPyschoticsRange/slider.png"
import slider7 from "../../Assets/Images/Product-page/AlzheimersManagement/slider.png"
import slider8 from "../../Assets/Images/Product-page/AntiVertigoRange/slider.png"
import slider9 from "../../Assets/Images/Product-page/PPIRange/slider.png"

import "./ProductRange.scss"
import { Link, Element } from 'react-scroll';

import sample from "../../Assets/Images/Product-page/Multivitamin/sample.png"
import { BookOpen, Info, ThumbsUp, AlertTriangle, PlayCircle, Activity, Shield } from "lucide-react";
import { MdPregnantWoman, MdMedicalServices, MdWarning } from 'react-icons/md';
import p1a from "../../Assets/Images/Product-page/Multivitamin/Ginkosmith Plus.jpg"
import p1b from "../../Assets/Images/Product-page/Multivitamin/Vitasmith Forte.jpg"
import p1c from "../../Assets/Images/Product-page/Multivitamin/Vitasmith D.jpg"
import p1d from "../../Assets/Images/Product-page/Multivitamin/GSS-D3.jpg"

import p2a from "../../Assets/Images/Product-page/AntidepressentRange/Esciday-CZ.jpg"
import p2b from "../../Assets/Images/Product-page/AntidepressentRange/Esciday-10.jpg"
import p2c from "../../Assets/Images/Product-page/AntidepressentRange/Desdoz-OD 50.jpg"
import p2d from "../../Assets/Images/Product-page/AntidepressentRange/Desdoz OD 100.jpg"
import p2e from "../../Assets/Images/Product-page/AntidepressentRange/Paroday CR 12.5.jpg"
import p2f from "../../Assets/Images/Product-page/AntidepressentRange/Paroday CZ.jpg"
import p2g from "../../Assets/Images/Product-page/AntidepressentRange/Duzan 20.jpg"
import p2h from "../../Assets/Images/Product-page/AntidepressentRange/Duzan 30.jpg"

import p3a from "../../Assets/Images/Product-page/NeuropathyManagement/Pgaba NT.jpg"
import p3b from "../../Assets/Images/Product-page/NeuropathyManagement/Pbdoz MNT.jpg"
import p3c from "../../Assets/Images/Product-page/NeuropathyManagement/PBDOZ-D.jpg"
import p3d from "../../Assets/Images/Product-page/NeuropathyManagement/GBdoz NT 100.jpg"
import p3e from "../../Assets/Images/Product-page/NeuropathyManagement/GBdoz NT 200.jpg"
import p3f from "../../Assets/Images/Product-page/NeuropathyManagement/GBdoz 300.jpg"
import p3g from "../../Assets/Images/Product-page/NeuropathyManagement/GBdoz NT 400.jpg"

import p4a from "../../Assets/Images/Product-page/AntiEpilepticRange/Leviday 500.jpg"
import p4b from "../../Assets/Images/Product-page/AntiEpilepticRange/Brivaday 50.jpg"
import p4c from "../../Assets/Images/Product-page/AntiEpilepticRange/Divalsmith 250 OD.jpg"
import p4d from "../../Assets/Images/Product-page/AntiEpilepticRange/Divalsmith 500 OD.jpg"

import p5a from "../../Assets/Images/Product-page/AnitMigraneRange/Mgday F 10.jpg"

import p6a from "../../Assets/Images/Product-page/AntiPyschoticsRange/Amidoz - 100.jpg"
import p6b from "../../Assets/Images/Product-page/AntiPyschoticsRange/Amidoz - 200.jpg"

import p7a from "../../Assets/Images/Product-page/AlzheimersManagement/Donza.jpg"
import p7b from "../../Assets/Images/Product-page/AlzheimersManagement/Donza M.jpg"

import p8a from "../../Assets/Images/Product-page/AntiVertigoRange/Vertidoz OD 24.jpg"
import p8b from "../../Assets/Images/Product-page/AntiVertigoRange/Vertidoz Od 48.jpg"
import p8c from "../../Assets/Images/Product-page/AntiVertigoRange/Dizicin MD.jpg"

import p9a from "../../Assets/Images/Product-page/PPIRange/Pantasmith DSR.jpg"
import p9b from "../../Assets/Images/Product-page/PPIRange/Rabesmith-DSR.jpg"

const MultivitaminRange = () => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    }, []);

    // sidebar

    const menuItems = [
        { icon: <BookOpen size={20} />, title: "Product description" },
        { icon: <Info size={20} />, title: "Uses" },
        { icon: <ThumbsUp size={20} />, title: "Benefits" },
        { icon: <AlertTriangle size={20} />, title: "Side effects" },
        { icon: <PlayCircle size={20} />, title: "How to use" },
        { icon: <Activity size={20} />, title: "How it works" },
        { icon: <Shield size={20} />, title: "Safety advice" },
    ];

    const sectionsRef = {
        "Product description": useRef(null),
        "Uses": useRef(null),
        "Benefits": useRef(null),
        "Side effects": useRef(null),
        "How to use": useRef(null),
        "How it works": useRef(null),
        "Safety advice": useRef(null),
    };
    // Function to scroll to a section
    const scrollToSection = (sectionTitle) => {
        setTimeout(() => {
            sectionsRef[sectionTitle]?.current?.scrollIntoView({
                behavior: "smooth",
                block: "center", // Adjust to prevent excessive scrolling
            });
        }, 100);
    };
    // product

    // poroduct range

    const products = [
        {
            id: 1,
            name: "Ginkosmith Plus",
            image: p1a,
            description: "Ginkgo biloba extract 120 mg, Magnesium 250 mg, N-acetyl L-cysteine 300 mg, L-arginine 200 mg, Vitamin C 40 mg, Zinc 12 mg, Vitamin E 8 mg, Vitamin A 600 mcg, Vitamin D2 10 mcg",
        },
        {
            id: 2,
            name: "Vitasmith Forte",
            image: p1b,
            description: "Benfothiamine 150 mg, Alpha lipoic acid 200 mg, Vitamin B12 1500 mcg, Calcium carbonate 500 mg, Inositol 100 mg, Chromium picolinate 200 mg, Pyridoxine 3 mg, Folic acid 1.5 mg, Vitamin D3 1000 IU (Mint fragrance tablets)",
        },
        {
            id: 3,
            name: "Vitasmith D",
            image: p1c,
            description: "Vitamin B12 1500 mcg, L-methylfolate calcium 1 mg, Pyridoxal-5-phosphate 0.5 mg, Vitamin D3 1000 IU sublingual tablets (Mango flavour)",
        },
        {
            id: 4,
            name: "GSS D3",
            image: p1d,
            description: "Cholecalciferol 60000 IU",
        },
    ];

    const products2 = [
        {
            id: 5,
            name: "Esciday CZ",
            image: p2a,
            description: "Escitalopram 10 mg + Clonazepam 0.5 mg",

        },
        {
            id: 6,
            name: "Esciday 10",
            image: p2b,
            description: "Escitalopram 10 mg",

        },
        {
            id: 7,
            name: "Desdoz OD-50",
            image: p2c,
            description: "Desvenlafaxine 50 mg",

        },
        {
            id: 8,
            name: "Desdoz OD-100",
            image: p2d,
            description: "Desvenlafaxine 100 mg",

        },
        {
            id: 9,
            name: "Paroday-CR 12.5",
            image: p2e,
            description: "Paroxetine 12.5 mg",

        },
        {
            id: 10,
            name: "Paroday-CZ ",
            image: p2f,
            description: "Paroxetine 12.5 mg + Clonazepam 0.5 mg",

        },
        {
            id: 11,
            name: "Duzan 20 ",
            image: p2g,
            description: "Duloxetine 20 mg",

        },
        {
            id: 12,
            name: "Duzan 30 ",
            image: p2h,
            description: "Duloxetine 30 mg",

        },
    ];

    const products3 = [
        {
            id: 13,
            name: "Pgaba NT",
            image: p3a,
            description: "Pregabalin 75 mg + Nortriptyline 10 mg",

        },
        {
            id: 14,
            name: "Pbdoz-MNT",
            image: p3b,
            description: "Pregabalin 75 mg + Nortriptyline 10 mg + Methylcobalamin 1500 mcg",

        },
        {
            id: 15,
            name: "Pbdoz-D",
            image: p3c,
            description: "Pregabalin 75 mg + Duloxetine 20 mg",

        },
        {
            id: 16,
            name: "Gbdoz NT 100 ",
            image: p3d,
            description: "Gabapentin 100 mg + Nortriptyline 10 mg",

        },

        {
            id: 17,
            name: "Gbdoz NT 200 ",
            image: p3e,
            description: "Gabapentin 200 mg + Nortriptyline 10 mg",

        },

        {
            id: 18,
            name: "Gbdoz 300",
            image: p3f,
            description: "Gabapentin 300 mg",

        },
        {
            id: 19,
            name: "Gbdoz NT 400",
            image: p3g,
            description: "Gabapentin 400 mg + Nortriptyline 10 mg",

        },

    ];

    const products4 = [
        {
            id: 20,
            name: "Leviday 500",
            image: p4a,
            description: "Levetiracetam 500 mg",
        },
        {
            id: 21,
            name: "Brivaday 50",
            image: p4b,
            description: "Brivaracetam 50 mg",

        },
        {
            id: 22,
            name: "Divalsmith OD 250",
            image: p4c,
            description: "Divalproex 250 mg",

        },
        {
            id: 23,
            name: "Divalsmith OD 500",
            image: p4d,
            description: "Divalproex 500 mg",

        },
    ];

    const products5 = [

        {
            id: 24,
            name: "Mgday F10",
            image: p5a,
            description: "Propranolol 40 mg + Flunarizine 10 mg"
        },
    ];

    const products6 = [
        {
            id: 25,
            name: "Amidoz 100",
            image: p6a,
            description: "Amisulpride 100 mg",

        },
        {
            id: 26,
            name: "Amidoz 200",
            image: p6b,
            description: "Amisulpride 200 mg"
        },

    ];

    const products7 = [
        {
            id: 27,
            name: "Donza",
            image: p7a,
            description: "Donepezil 5 mg",

        },
        {
            id: 28,
            name: "Donza-M",
            image: p7b,
            description: "Donepezil 5 mg + Memantine 5 mg",
        },

    ];

    const products8 = [
        {
            id: 29,
            name: "Vertidoz OD 24",
            image: p8a,
            description: "Betahistine 24 mg",

        },
        {
            id: 30,
            name: "Vertidoz OD 48",
            image: p8b,
            description: "Betahistine 48 mg",
        },
        {
            id: 31,
            name: "Dizicin MD",
            image: p8c,
            description: "Cinnarizine 20 mg + Dimenhydrinate 40 mg",
        },
    ];

    const products9 = [
        {
            id: 33,
            name: "Pantasmith DSR",
            image: p9a,
            description: "Pantoprazole 40 mg + Domperidone 30 mg",

        },
        {
            id: 32,
            image: p9b,
            name: "Rabesmith DSR",
            description: "Rabeprazole 20 mg + Domperidonez 30 mg	"
        },

    ];



    const [visibleProductId, setVisibleProductId] = useState(null);

    const toggleProductDetails = (productId) => {
        setVisibleProductId(prevId => prevId === productId ? null : productId);
    };

    const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const section = document.getElementById(id);

      if (section) {
        const yOffset = -200; // adjust as needed
        const yPosition = section.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
          top: yPosition,
          behavior: "smooth",
        });
      }
    }
  }, [location]);


    return (
        <div>
            <div className="product-page">

                <div className="product-sidebar">
                    <Link to="product1" spy={true} smooth={true} offset={-180} duration={500} ><div><div><svg id="Camada_1" enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m20 1h-16c-1.7 0-3 1.3-3 3v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-16c0-1.7-1.3-3-3-3zm-2 12h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" /></svg></div></div>Multivitamin Range </Link>
                    <Link to="product2" spy={true} smooth={true} offset={-180} duration={500}><div><svg id="Camada_1" enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m20 1h-16c-1.7 0-3 1.3-3 3v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-16c0-1.7-1.3-3-3-3zm-2 12h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" /></svg></div>Antidepressent Range </Link>
                    <Link to="product3" spy={true} smooth={true} offset={-180} duration={500}><div><svg id="Camada_1" enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m20 1h-16c-1.7 0-3 1.3-3 3v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-16c0-1.7-1.3-3-3-3zm-2 12h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" /></svg></div>Neuropathy Pain Management</Link>
                    <Link to="product4" spy={true} smooth={true} offset={-180} duration={500}><div><svg id="Camada_1" enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m20 1h-16c-1.7 0-3 1.3-3 3v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-16c0-1.7-1.3-3-3-3zm-2 12h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" /></svg></div>Anti Epileptic Range </Link>
                    <Link to="product5" spy={true} smooth={true} offset={-180} duration={500}><div><svg id="Camada_1" enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m20 1h-16c-1.7 0-3 1.3-3 3v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-16c0-1.7-1.3-3-3-3zm-2 12h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" /></svg></div>Anti Migraine Range </Link>
                    <Link to="product6" spy={true} smooth={true} offset={-180} duration={500}><div><svg id="Camada_1" enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m20 1h-16c-1.7 0-3 1.3-3 3v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-16c0-1.7-1.3-3-3-3zm-2 12h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" /></svg></div>Anti Psychotic Range </Link>
                    <Link to="product7" spy={true} smooth={true} offset={-180} duration={500}><div><svg id="Camada_1" enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m20 1h-16c-1.7 0-3 1.3-3 3v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-16c0-1.7-1.3-3-3-3zm-2 12h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" /></svg></div>Anti Alzheimer Range </Link>
                    <Link to="product8" spy={true} smooth={true} offset={-180} duration={500}><div><svg id="Camada_1" enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m20 1h-16c-1.7 0-3 1.3-3 3v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-16c0-1.7-1.3-3-3-3zm-2 12h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" /></svg></div>Anti Vertigo Range </Link>
                    <Link to="product9" spy={true} smooth={true} offset={-180} duration={500}><div><svg id="Camada_1" enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m20 1h-16c-1.7 0-3 1.3-3 3v16c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3v-16c0-1.7-1.3-3-3-3zm-2 12h-5v5h-2v-5h-5v-2h5v-5h2v5h5z" /></svg></div>PPIs</Link>
                </div>

                <div className="product-right">
                    {/* multivitamin range*/}
                    <Element name="product1" id='multivitaminRange'>
                        <div className="product-slider">

                            <div className='slider-text'>
                                <h1>Multivitamin range</h1>
                                <p>Vitamins are essential for the proper functioning of the nerves. Vitamin deficiency leads to a decrease in the production of myelin sheath. It is this membrane that is responsible for the preservation of nerve cells. Lack of vitamins reduces energy metabolism and destroys nerve cells. As a result, a person has problems with numbness, depression, and cognitive decline.</p>
                            </div>
                            <div className="slider-img">
                                <img src={slider} alt="multivitamin range" />
                            </div>
                        </div>

                        <div className="product-body">
                            {/* <div className='slider-text'>
                        <h1>Multivitamin range</h1>
                        <p>Vitamins are essential for the proper functioning of the nerves. Vitamin deficiency leads to a decrease in the production of myelin sheath. It is this membrane that is responsible for the preservation of nerve cells. Lack of vitamins reduces energy metabolism and destroys nerve cells. As a result, a person has problems with numbness, depression, and cognitive decline.</p>

                    </div> */}
                            {products.map((product) => (
                                <div className="product-card" key={product.id} onClick={() => toggleProductDetails(product.id)}>
                                    <div className="img">
                                        <div className="img">
                                            <img src={product.image} alt={product.name} />
                                        </div>
                                    </div>
                                    {visibleProductId === product.id && (
                                        <p>{product.description}</p>
                                    )}

                                    <div className="product-card-text">
                                        <h3>{product.name}</h3>

                                        {/* <button className="quote-btn" onClick={() => toggleProductDetails(product.id)}>
                                            {visibleProductId === product.id ? "Show Less" : "Learn More"}
                                        </button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Element>
                    {/* multivitamin range ends*/}

                    {/* anti depressant range */}
                    <Element name="product2" id="antidepressentRange">
                        <div className="product-slider">
                            <div className='slider-text'>
                                <h1>Antidepressent range</h1>
                                <p>Antidepressants are a class of medications used to treat depression and other mental health conditions. They work by affecting neurotransmitters (chemical messengers in the brain) that play a role in mood regulation, such as serotonin and norepinephrine. </p>
                            </div>
                            <div className="slider-img">
                                <img style={{ width: "70%", marginLeft: "10%", marginTop: "-5%" }} src={slider2} alt="multivitamin range" />
                            </div>
                        </div>

                        <div className="product-body">
                            {/* <div className='slider-text2'>
                        <h1>Anti Depressent</h1>
                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Non suscipit totam eius quasi velit, doloribus, eum exercitationem quo, sapiente et est beatae repudiandae! Accusamus aliquam, id placeat accusantium hic facere.</p>
                    </div> */}
                            {products2.map((product) => (
                               <div className="product-card" key={product.id} onClick={() => toggleProductDetails(product.id)}>
                                    <div className="img">
                                        <div className="img">
                                            <img src={product.image} alt={product.name} />
                                        </div>
                                    </div>
                                    {visibleProductId === product.id && (
                                        <p>{product.description}</p>
                                    )}
                                    <div className="product-card-text">
                                        <h3>{product.name}</h3>

                                       {/* <button className="quote-btn" onClick={() => toggleProductDetails(product.id)}>
                                            {visibleProductId === product.id ? "Show Less" : "Learn More"}
                                        </button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Element>
                    {/* anti depressant range ends */}

                    {/* Neuropathy pain management */}
                    <Element name="product3" id="neuropathyManagement">
                        <div className="product-slider">
                            <div className='slider-text'>
                                <h1>Neuropathy Pain Management</h1>
                                <p>Neuropathic pain is nerve pain that can happen if your nervous system malfunctions or gets damaged. You can feel pain from any of the various levels of your nervous system, including your peripheral nerves, your spinal cord and your brain. </p>
                            </div>
                            <div className="slider-img">
                                <img style={{ width: "60%", display: "block", margin: "auto", marginTop: "-10%" }} src={slider3} alt="multivitamin range" />
                            </div>
                        </div>

                        <div className="product-body">

                            {products3.map((product) => (
                               <div className="product-card" key={product.id} onClick={() => toggleProductDetails(product.id)}>
                                    <div className="img">
                                        <div className="img">
                                            <img src={product.image} alt={product.name} />
                                        </div>
                                    </div>
                                    {visibleProductId === product.id && (
                                        <p>{product.description}</p>
                                    )}
                                    <div className="product-card-text">
                                        <h3>{product.name}</h3>
                                       {/* <button className="quote-btn" onClick={() => toggleProductDetails(product.id)}>
                                            {visibleProductId === product.id ? "Show Less" : "Learn More"}
                                        </button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Element>
                    {/* Neuropathy pain management ends */}


                    {/* Anti Epileptic range */}
                    <Element name="product4" id="antiEpilepticRange">
                        <div className="product-slider">
                            <div className='slider-text'>
                                <h1>Anti Epileptic range</h1>
                                <p>Anti-epileptic drugs are used to treat and prevent seizures, which are sudden, uncontrolled electrical disturbances in the brain that can cause a variety of symptoms, including loss of consciousness, muscle spasms, and altered sensations. These medications work by altering the electrical activity in the brain, either by decreasing excitation or enhancing inhibition, to prevent seizures from occurring or to reduce their severity. </p>
                            </div>
                            <div className="slider-img">
                                <img style={{ width: "80%", marginLeft: "10%", marginTop: "-5%" }} src={slider4} alt="multivitamin range" />
                            </div>
                        </div>

                        <div className="product-body">

                            {products4.map((product) => (
                               <div className="product-card" key={product.id} onClick={() => toggleProductDetails(product.id)}>
                                    <div className="img">
                                        <div className="img">
                                            <img src={product.image} alt={product.name} />
                                        </div>
                                    </div>
                                    {visibleProductId === product.id && (
                                        <p>{product.description}</p>
                                    )}
                                    <div className="product-card-text">
                                        <h3>{product.name}</h3>
                                       {/* <button className="quote-btn" onClick={() => toggleProductDetails(product.id)}>
                                            {visibleProductId === product.id ? "Show Less" : "Learn More"}
                                        </button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Element>
                    {/* Anti Epileptic range ends */}

                    {/* ANTI MIGRAINe RANGE */}
                    <Element name="product5" id="antiMigraineRange">
                        <div className="product-slider">
                            <div className='slider-text'>
                                <h1>Anti Migraine Range</h1>
                                <p>Antimigraine drugs are medications used to prevent or lessen the intensity of migraine headaches, which are characterized by symptoms like nausea, vomiting, and sensitivity to light. These drugs include various types such as triptans, β-blockers, anticonvulsants, and others, aimed at treating acute migraine episodes or preventing them.</p>
                            </div>
                            <div className="slider-img">
                                <img style={{ width: "80%", marginLeft: "10%", marginTop: "-5%" }} src={slider5} alt="multivitamin range" />
                            </div>
                        </div>

                        <div className="product-body">

                            {products5.map((product) => (
                               <div className="product-card" key={product.id} onClick={() => toggleProductDetails(product.id)}>
                                    <div className="img">
                                        <div className="img">
                                            <img src={product.image} alt={product.name} />
                                        </div>
                                    </div>
                                    {visibleProductId === product.id && (
                                        <p>{product.description}</p>
                                    )}
                                    <div className="product-card-text">
                                        <h3>{product.name}</h3>
                                        {/* <button className="quote-btn" onClick={() => toggleProductDetails(product.id)}>
                                            {visibleProductId === product.id ? "Show Less" : "Learn More"}
                                        </button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Element>
                    {/* ANTI MIGRAIN RANGE ends */}

                    {/* ANTI PSYCHOTIC RANGE */}
                    <Element name="product6" id="antiPsychoticRange">
                        <div className="product-slider product-slider">
                            <div className='slider-text'>
                                <h1>Anti Psychotic range</h1>
                                <p>Antipsychotics are medications primarily used to treat psychosis, a condition characterized by hallucinations, delusions, and disorganized thoughts. Antipsychotic medications work by influencing neurotransmitters, especially dopamine, in the brain. They block dopamine receptors, which helps to reduce the overactivity of dopamine pathways associated with psychotic symptoms. </p>
                            </div>
                            <div className="slider-img">
                                <img style={{ width: "70%", marginLeft: "10%", marginTop: "-5%" }} src={slider6} alt="multivitamin range" />
                            </div>
                        </div>

                        <div className="product-body">

                            {products6.map((product) => (
                               <div className="product-card" key={product.id} onClick={() => toggleProductDetails(product.id)}>
                                    <div className="img">
                                        <div className="img">
                                            <img src={product.image} alt={product.name} />
                                        </div>
                                    </div>
                                    {visibleProductId === product.id && (
                                        <p>{product.description}</p>
                                    )}
                                    <div className="product-card-text">
                                        <h3>{product.name}</h3>
                                        {/* <button className="quote-btn" onClick={() => toggleProductDetails(product.id)}>
                                            {visibleProductId === product.id ? "Show Less" : "Learn More"}
                                        </button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Element>
                    {/* ANTI PSYCHOTIC RANGE ends */}

                    {/* ANTI ALZEIMER RANGE */}
                    <Element name="product7" id="alzhiemersManagement">
                        <div className="product-slider">
                            <div className='slider-text'>
                                <h1>Anti Alzheimer Range</h1>
                                <p>Alzheimer's disease is a progressive neurodegenerative disorder that primarily affects memory and thinking skills, eventually impacting daily life. </p>
                            </div>
                            <div className="slider-img">
                                <img style={{ width: "80%", marginLeft: "10%", marginTop: "-5%" }} src={slider7} alt="multivitamin range" />
                            </div>
                        </div>

                        <div className="product-body">

                            {products7.map((product) => (
                               <div className="product-card" key={product.id} onClick={() => toggleProductDetails(product.id)}>
                                    <div className="img">
                                        <div className="img">
                                            <img src={product.image} alt={product.name} />
                                        </div>
                                    </div>
                                    {visibleProductId === product.id && (
                                        <p>{product.description}</p>
                                    )}
                                    <div className="product-card-text">
                                        <h3>{product.name}</h3>
                                        {/* <button className="quote-btn" onClick={() => toggleProductDetails(product.id)}>
                                            {visibleProductId === product.id ? "Show Less" : "Learn More"}
                                        </button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Element>
                    {/* ANTI ALZEIMER RANGE ends */}

                    {/* ANTI VERTIGO RANGE */}
                    <Element name="product8" id="antiVertigoRange">
                        <div className="product-slider product-slider">
                            <div className='slider-text'>
                                <h1>Anti Vertigo range</h1>
                                <p>Anti-vertigo agents, also known as vestibular suppressants, are medications used to relieve the symptoms of vertigo, a sensation of spinning or dizziness, and associated nausea and vomiting. These drugs work by modulating the vestibular sensory network, reducing the transmission of sensory information related to vertigo episodes. </p>
                            </div>
                            <div className="slider-img">
                                <img style={{ width: "70%", display: "block", margin: "auto" }} src={slider8} alt="multivitamin range" />
                            </div>
                        </div>

                        <div className="product-body">

                            {products8.map((product) => (
                               <div className="product-card" key={product.id} onClick={() => toggleProductDetails(product.id)}>
                                    <div className="img">
                                        <div className="img">
                                            <img src={product.image} alt={product.name} />
                                        </div>
                                    </div>
                                    {visibleProductId === product.id && (
                                        <p>{product.description}</p>
                                    )}
                                    <div className="product-card-text">
                                        <h3>{product.name}</h3>
                                        {/* <button className="quote-btn" onClick={() => toggleProductDetails(product.id)}>
                                            {visibleProductId === product.id ? "Show Less" : "Learn More"}
                                        </button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Element>
                    {/* ANTI VERTIGO RANGE ends */}

                    {/* PPIs */}
                    <Element name="product9" id="ppiRange">
                        <div className="product-slider">
                            <div className='slider-text'>
                                <h1>PPIs</h1>
                                <p>Proton pump inhibitors (PPIs) are a class of drugs that reduce stomach acid production. They work by blocking the hydrogen-potassium ATPase pump, also known as the proton pump, which is responsible for secreting acid in the stomach. PPIs are commonly used to treat conditions like acid reflux (GERD), peptic ulcers, and in combination with antibiotics to eradicate Helicobacter pylori infections. </p>
                            </div>
                            <div className="slider-img">
                                <img src={slider9} alt="multivitamin range" />
                            </div>
                        </div>

                        <div className="product-body" style={{ marginBottom: "5%", borderBottom: "none" }}>

                            {products9.map((product) => (
                               <div className="product-card" key={product.id} onClick={() => toggleProductDetails(product.id)}>
                                    <div className="img">
                                        <div className="img">
                                            <img src={product.image} alt={product.name} />
                                        </div>
                                    </div>
                                    {visibleProductId === product.id && (
                                        <p>{product.description}</p>
                                    )}
                                    <div className="product-card-text">
                                        <h3>{product.name}</h3>
                                       {/* <button className="quote-btn" onClick={() => toggleProductDetails(product.id)}>
                                            {visibleProductId === product.id ? "Show Less" : "Learn More"}
                                        </button> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Element>
                    {/* PPIs ends */}
                </div>


            </div>
        </div>

    )
}

export default MultivitaminRange